export const Key = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
  >
    <path
      d="M6.23592 1.06991C7.28587 2.11985 7.56439 3.65195 7.06879 4.95542L11.989 9.87559L12.2128 12L9.40596 11.5193L9.28856 10.2278L7.99706 10.1104L7.87964 8.81894L6.58814 8.70152L4.95542 7.06878C3.65196 7.5644 2.11986 7.28587 1.06991 6.23592C-0.356638 4.80937 -0.356636 2.49646 1.06991 1.06992C2.49646 -0.356633 4.80937 -0.356641 6.23592 1.06991ZM3.53551 2.12659C3.14645 1.73753 2.51565 1.73754 2.12659 2.1266C1.73753 2.51566 1.73754 3.14645 2.12659 3.53551C2.51565 3.92457 3.14645 3.92456 3.5355 3.5355C3.92456 3.14644 3.92456 2.51565 3.53551 2.12659Z"
      fill="#103ECC"
    />
  </svg>
);
